const RippleIcon = ({ color, size = 24 }: { color: string; size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      {/* Center dot */}
      <circle cx="12" cy="12" r="4" fill={color} />
      {/* Ripple circles with animation */}
      <circle cx="12" cy="12" r="4" fill="none" stroke={color} strokeWidth="1.5" opacity="0.8">
        <animate attributeName="r" values="4;11" dur="3s" repeatCount="indefinite" calcMode="ease-out" />
        <animate attributeName="opacity" values="0.8;0" dur="3s" repeatCount="indefinite" calcMode="ease-out" />
      </circle>
      <circle cx="12" cy="12" r="4" fill="none" stroke={color} strokeWidth="1.5" opacity="0.8">
        <animate attributeName="r" values="4;11" dur="3s" begin="1.5s" repeatCount="indefinite" calcMode="ease-out" />
        <animate
          attributeName="opacity"
          values="0.8;0"
          dur="3s"
          begin="1.5s"
          repeatCount="indefinite"
          calcMode="ease-out"
        />
      </circle>
    </svg>
  )
}

export default RippleIcon
